import { DEBUG_ALERT_MSG } from '../config';
import { throttle } from './schedulers';
import { getAllMultitabTokens } from './establishMultitabRole';
import { IS_MULTITAB_SUPPORTED } from './windowEnvironment';

window.addEventListener('error', handleErrorEvent);
window.addEventListener('unhandledrejection', handleErrorEvent);

// eslint-disable-next-line prefer-destructuring
const APP_ENV = process.env.APP_ENV;

function handleErrorEvent(e: ErrorEvent | PromiseRejectionEvent) {
  if (
    e instanceof ErrorEvent &&
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    return;
  }

  e.preventDefault();

  handleError(e instanceof ErrorEvent ? e.error || e.message : e.reason);
}

const throttledAlert = throttle((message: string) => {
  if (IS_MULTITAB_SUPPORTED && getAllMultitabTokens().length > 1) {
    return;
  }
  // eslint-disable-next-line no-alert
  window.alert(message);
}, 1000);

export function handleError(err: Error | string) {
  const message = typeof err === 'string' ? err : err?.message || String(err);
  const stack = typeof err === 'string' ? '' : err?.stack || '';

  const isRecaptchaLoggingError =
    message.includes("reading 'logging'") && stack.includes('recaptcha__');

  if (isRecaptchaLoggingError) {
    console.warn('[recaptcha] Ignored known logging bug:', message);
    return;
  }

  // eslint-disable-next-line no-console
  console.error(err);

  throttledAlert(`${DEBUG_ALERT_MSG}\n\n${message}\n${stack}`);
}
